<app-spinner-overlay></app-spinner-overlay>

<!-- ═══════════════════════════════════════════════════════════════
     HEADER
════════════════════════════════════════════════════════════════ -->
<div class="dlg-header">
  <p class="dlg-title">Selezione ESRS</p>
  <p class="dlg-subtitle">
    Seleziona la temtaica oppure i temi e i relativi sottotemi da legare alla tematica.
  </p>
</div>

<!-- ═══════════════════════════════════════════════════════════════
     BODY — albero gerarchico
════════════════════════════════════════════════════════════════ -->
<div class="dlg-body">
  <ng-scrollbar>
    <div class="tree-wrapper">
      <!-- ── Radice: Tematica ─────────────────────────────────────── -->
      <div class="tree-root-row">
        <mat-checkbox
          color="primary"
          [checked]="tematicaIncludi"
          (change)="onChangeTematica($event)"
          [disabled]="data.readOnly"
        >
          <span class="node-label">
            @if (data.isAziendale) {
              <span class="badge-tematica-aziendale" matTooltip="Tematica aziendale">
                Aziendale
              </span>
            }
            <span class="badge badge--tematica">Tematica</span>
            <span class="node-text node-text">{{ data.domandaTematica }}</span>
          </span>
        </mat-checkbox>
      </div>

      <!-- ── Livello 1: Temi ──────────────────────────────────────── -->
      <div class="tree-branch tree-branch--l1">
        @for (tema of esrs; track tema.id) {
          <div>
            <!-- Riga Tema -->
            <div class="tree-row tree-row--tema">
              <ng-container
                *ngTemplateOutlet="
                  checkboxOrLabel;
                  context: {
                    $implicit: tema,
                    badge: 'Tema',
                    badgeClass: 'badge--tema',
                    checked: tema.includi,
                    indeterminate: isIndeterminate(tema),
                    onChange: onChangeTema.bind(this),
                    extraArg: tema,
                  }
                "
              ></ng-container>
            </div>

            <!-- Livello 2: SottoTemi -->
            @if (tema.sottoTemi.length) {
              <div class="tree-branch tree-branch--l2">
                @for (sottoTema of tema.sottoTemi; track sottoTema.id) {
                  <div>
                    <!-- Riga SottoTema -->
                    <div class="tree-row tree-row--sottotema">
                      <mat-checkbox
                        [color]="isIndeterminate(sottoTema) ? 'accent' : 'primary'"
                        [checked]="sottoTema.includi"
                        [indeterminate]="isIndeterminate(sottoTema)"
                        (change)="onChangeSottoTema($event, tema, sottoTema)"
                        (click)="$event.stopPropagation()"
                        [disabled]="data.readOnly || !sottoTema.selected"
                      >
                        <span class="node-label" [class.node-label--readonly]="!sottoTema.selected">
                          <span
                            class="badge badge--sottotema"
                            [class.badge--muted]="!sottoTema.selected"
                          >
                            SottoTema
                          </span>

                          <span class="node-text">{{ sottoTema.nomeBreve }}</span>

                          @if (sottoTema.descrizione) {
                            <span class="node-desc"> – {{ sottoTema.descrizione }}</span>
                          }
                        </span>
                      </mat-checkbox>
                    </div>

                    <!-- Livello 3: SottoSottoTemi -->
                    @if (sottoTema.sottoTemi.length) {
                      <div class="tree-branch tree-branch--l3">
                        @for (sst of sottoTema.sottoTemi; track sst.id) {
                          <div>
                            <div class="tree-row tree-row--sst">
                              @if (sst.selected) {
                                <mat-checkbox
                                  color="primary"
                                  [checked]="sst.includi"
                                  (change)="onChangeSottoSottoTema($event, tema, sottoTema, sst)"
                                  (click)="$event.stopPropagation()"
                                  [disabled]="data.readOnly"
                                >
                                  <span class="node-label">
                                    <span class="badge badge--sst">Sotto-SottoTema</span>
                                    <span class="node-text node-text--sm">{{ sst.nomeBreve }}</span>
                                    @if (sst.descrizione) {
                                      <span class="node-desc"> – {{ sst.descrizione }}</span>
                                    }
                                  </span>
                                </mat-checkbox>
                              } @else {
                                <span class="node-label node-label--readonly">
                                  <span class="badge badge--sst badge--muted">Sotto-SottoTema</span>
                                  <span class="node-text node-text--sm">{{ sst.nomeBreve }}</span>
                                  @if (sst.descrizione) {
                                    <span class="node-desc"> – {{ sst.descrizione }}</span>
                                  }
                                </span>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </ng-scrollbar>
</div>

<!-- ═══════════════════════════════════════════════════════════════
                 FOOTER
════════════════════════════════════════════════════════════════ -->
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Indietro</button>
  </div>
  @if (!data.readOnly) {
    <div>
      <button mat-flat-button color="primary" (click)="conferma()" class="primary-button">
        Conferma
      </button>
    </div>
  }
</div>

<!-- ═══════════════════════════════════════════════════════════════
     TEMPLATE: checkbox se selected, label muted altrimenti
     Nota: usato solo per il livello Tema per non duplicare markup.
     SottoTema e SST sono inline per consentire binding differenziati.
════════════════════════════════════════════════════════════════ -->
<ng-template #checkboxOrLabel let-item let-badge="badge" let-badgeClass="badgeClass">
  <mat-checkbox
    [color]="isIndeterminate(item) ? 'accent' : 'primary'"
    [checked]="item.includi"
    [indeterminate]="isIndeterminate(item)"
    (change)="onChangeTema($event, item)"
    (click)="$event.stopPropagation()"
    [disabled]="data.readOnly || !item.selected"
  >
    <span class="node-label" [class.node-label--readonly]="!item.selected">
      <span class="badge" [ngClass]="badgeClass" [class.badge--muted]="!item.selected">
        {{ badge }}
      </span>

      <span class="node-text node-text">{{ item.nomeBreve }}</span>

      @if (item.descrizione) {
        <span class="node-desc"> – {{ item.descrizione }}</span>
      }
    </span>
  </mat-checkbox>
</ng-template>
